const API = process.env.REACT_APP_BACKEND_URL;

export async function api(path, { method = 'GET', body } = {}) {
  const headers = { Authorization: `Bearer ${localStorage.getItem('adminToken')}` };
  if (body) headers['Content-Type'] = 'application/json';
  const res = await fetch(`${API}/api/admin/payment-plans${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    window.location.href = '/admin-login';
    throw new Error('Session expired');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Request failed');
  return data;
}

export const aud = (n) =>
  n === null || n === undefined
    ? '—'
    : new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: Number(n) % 1 === 0 ? 0 : 2,
      }).format(n);

export const toDate = (s) => (s && s.length === 10 ? new Date(`${s}T00:00:00`) : new Date(s));

export const fmtDate = (s, opts = { day: '2-digit', month: 'short', year: 'numeric' }) =>
  s ? toDate(s).toLocaleDateString('en-AU', opts) : '—';

export const fmtShort = (s) => fmtDate(s, { day: '2-digit', month: '2-digit' });

export const isoDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const FREQ_LABEL = { weekly: 'Weekly', fortnightly: 'Fortnightly', monthly: 'Monthly', other: 'Other' };

export const freqLabel = (p) =>
  p.frequency === 'other'
    ? `Every ${p.interval_count} ${p.interval_unit === 'months' ? 'month' : 'day'}${p.interval_count === 1 ? '' : 's'}`
    : FREQ_LABEL[p.frequency];

export const addPeriod = (d, f, n) => {
  const out = new Date(d);
  const count = Number(f.interval_count) || 1;
  if (f.frequency === 'monthly') out.setMonth(out.getMonth() + n);
  else if (f.frequency === 'other' && f.interval_unit === 'months') out.setMonth(out.getMonth() + count * n);
  else out.setDate(out.getDate() + n * (f.frequency === 'weekly' ? 7 : f.frequency === 'fortnightly' ? 14 : count));
  return out;
};

export const STATUS_STYLES = {
  'On Track': 'bg-[#7BA05B]/15 text-[#4A6B2E] border-[#7BA05B]/30',
  'Payment Due': 'bg-[#D4A574]/20 text-[#8B6B4A] border-[#D4A574]/40',
  Overdue: 'bg-[#C0392B] text-white border-[#C0392B]',
  'Follow Up Sent': 'bg-[#6B8FA3]/15 text-[#3A5A6B] border-[#6B8FA3]/30',
  Escalated: 'bg-[#7A3B69]/15 text-[#7A3B69] border-[#7A3B69]/30',
  Completed: 'bg-[#E8E4DC] text-[#6B6560] border-[#E8E4DC]',
};

export const STATUS_ORDER = { Overdue: 0, 'Payment Due': 1, 'Follow Up Sent': 2, Escalated: 3, 'On Track': 4, Completed: 5 };

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');
